import { Field, FieldAttributes } from 'formik';
import React from 'react';
import StyledErrorMessage from './StyledErrorMessage';

type FieldWithErrorProps = FieldAttributes<unknown>;

const FieldWithError: React.FC<FieldWithErrorProps> = ({ name, ...rest }: FieldWithErrorProps) => {
  return (
    <>
      <Field name={name} {...rest}></Field>
      <StyledErrorMessage name={name}></StyledErrorMessage>
    </>
  );
};

export default FieldWithError;
